import { CannabisPrimaryRoute } from "./CannabisPrimaryRoute";
import { TimesUsedUnit } from "./TimesUsedUnit";

class BritishColumbiaObstetricalFileCannabis {
    public ConsumedThreeMonthsBeforePregnancy?: boolean;
    public ConsumesDuringPregnancy?: boolean;
    public ConsumedCannabidiolOnlyThreeMonthsBeforePregnancy?: boolean;
    public ConsumesCannabidiolOnlyDuringPregnancy?: boolean;
    public TimesUsedPerUnitThreeMonthsBeforePregnancy?: number;
    public TimesUsedUnitThreeMonthsBeforePregnancy?: TimesUsedUnit = null;
    public TimesUsedPerUnitDuringPregnancy?: number;
    public TimesUsedUnitDuringPregnancy?: TimesUsedUnit = null;
    public PrimaryRouteThreeMonthsBeforePregnancy?: CannabisPrimaryRoute;
    public PrimaryRouteDuringPregnancy?: CannabisPrimaryRoute;
    public HasQuitCannabis?: boolean;
    public QuitCannabisDate: Date;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileCannabis>) {
        this.TimesUsedUnitThreeMonthsBeforePregnancy = TimesUsedUnit.Week;
        this.TimesUsedUnitDuringPregnancy = TimesUsedUnit.Week;
        Object.assign(this, fields);
    }

    public hasSelectedAnySubFieldsOfConsumedThreeMonthsBeforePregnancy(): boolean {
        return this.ConsumedCannabidiolOnlyThreeMonthsBeforePregnancy
            || !!this.TimesUsedPerUnitThreeMonthsBeforePregnancy
            || !!this.PrimaryRouteThreeMonthsBeforePregnancy;
    }

    public hasSelectedAnySubFieldsOfConsumesDuringPregnancy(): boolean {
        return this.ConsumesCannabidiolOnlyDuringPregnancy
            || !!this.TimesUsedPerUnitDuringPregnancy
            || !!this.PrimaryRouteDuringPregnancy;
    }
}

export { BritishColumbiaObstetricalFileCannabis };
